// DebugPanel.js
'use client';
import { connect } from 'react-redux';
import { goBack } from 'redux-first-history';

import checkNetworkSpeed, {
  trackSpeedtestEvent,
} from '../action/checkNetworkSpeed.js';
import recheckDrmCapability from '../action/recheckDrmCapability.js';
import { handleRefreshToken } from '../action/fetchAccessToken.js';
import getFpIdPro from '../action/getFpIdPro.js';
import postMessageToApp from '../action/postMessageToApp.js';

import getOperationData from '../selector/getOperationData.js';
import getExternalData from '../selector/getExternalData.js';
import getMeData from '../selector/getMeData.js';
import getMissingFpProRemoteConfigReason from '../selector/getMissingFpProRemoteConfigReason.js';

import DebugPanel from '../page/DebugPanel.jsx';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

import { SpeedtestState } from '../resource/speedtestConstants.js';

import { SPEEDTEST_SERVERS } from '../RemoteConfigKeys.js';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';
import { getHeaders } from '../resource/fetchOptionHeader.js';

const mapStateToProps = state => {
  const testState = getOperationData(state, ['speedtest'], 'testState');
  const isSpeedtesting = [
    SpeedtestState.ADDING_SETTINGS,
    SpeedtestState.ADDING_SERVERS,
    SpeedtestState.SERVER_SELECTION_DONE,
    SpeedtestState.TEST_RUNNING,
  ].includes(testState);
  const isSpeedtested = testState === SpeedtestState.DONE;

  return {
    isSpeedtesting,
    isSpeedtested,
    jitterStatus: getOperationData(state, ['speedtest'], 'jitterStatus'),
    pingStatus: getOperationData(state, ['speedtest'], 'pingStatus'),
    dlProgress: getOperationData(state, ['speedtest'], 'dlProgress'),
    ulProgress: getOperationData(state, ['speedtest'], 'ulProgress'),
    dlStatus: getOperationData(state, ['speedtest'], 'dlStatus'),
    ulStatus: getOperationData(state, ['speedtest'], 'ulStatus'),
    speedtestUnixTimestamp: getOperationData(
      state,
      ['speedtest'],
      'speedtestUnixTimestamp'
    ),
    drmTestStatus: getOperationData(state, ['drm'], 'testStatus'),
    drmTestAtUnixTimestamp: getOperationData(
      state,
      ['drm'],
      'testedAtUnixTimestamp'
    ),
    pusherStatsInitSpeed: getOperationData(
      state,
      ['pusher', 'stats'],
      'initSpeed'
    ),
    pusherStatsConnectSpeed: getOperationData(
      state,
      ['pusher', 'stats'],
      'connectSpeed'
    ),
    messageId: getOperationData(state, ['drm'], 'messageId'),
    abData: getMeData(state, 'ab'),
    notificationPermission: getOperationData(
      state,
      ['permission'],
      'notification'
    ),
    fcmToken: getMeData(state, 'fcmToken'),
    clientTimestamp: getExternalData(state, ['timestamp'], 'client'),
    serverTimestamp: getExternalData(state, ['timestamp'], 'server'),
    id: getMeData(state, 'id'),
    clientId: getMeData(state, 'clientId'),
    sessionId: getMeData(state, 'sessionId'),
    configurationData: getOperationData(state, ['config'], 'configurationData'),
    configurationGroups: getOperationData(
      state,
      ['config'],
      'configurationGroups'
    ),
    remoteConfigMerged: getOperationData(
      state,
      ['config'],
      'remoteConfigMerged'
    ),
    currentConfigIds: getOperationData(state, ['config'], 'currentConfigIds'),
    currentConfigKey: getOperationData(state, ['config'], 'currentConfigKey'),
    remoteConfig: state.get('remoteConfig'),
    speedtestServersUrl: getRemoteConfigData(state, SPEEDTEST_SERVERS),
    isElementIdDebugTrackingEnabled: getOperationData(
      state,
      ['debug', 'tracking'],
      'elementId'
    ),
    pusherConnectionState: getOperationData(
      state,
      ['pusher', 'connection'],
      'state'
    ),
    presenceUserSubscribeState: getOperationData(state, [
      'pusher',
      'channels',
      `presence-enc-user@${getMeData(state, 'id')}`,
    ]),
    presenceClientSubscribeState: getOperationData(state, [
      'pusher',
      'channels',
      `presence-enc-client@${getMeData(state, 'clientId')}`,
    ]),
    pusherSubscribedStates: getOperationData(state, ['pusher'], 'channels'),
    refreshToken: getMeData(state, 'refreshToken'),
    jwtData: getMeData(state, 'jwtData'),
    refreshTokenJwtData: getMeData(state, 'refreshTokenJwtData'),
    fpIdOSS: getOperationData(state, ['fingerprint'], 'fpIdOSS'),
    fpIdPro: getOperationData(state, ['fingerprint'], 'fpIdPro'),
    xTrack: getHeaders()?.['X-Track'],
    missingFpProRemoteConfigReason: getMissingFpProRemoteConfigReason(state),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    goBack: () => dispatch(goBack()),
    checkNetworkSpeed: ({ speedtestServersUrl }) =>
      dispatch(checkNetworkSpeed({ speedtestServersUrl })),
    recheckDrmCapability: () => dispatch(recheckDrmCapability()),
    trackSpeedtestEvent: () => dispatch(trackSpeedtestEvent()),
    updateDebugTracking: ({ key, value }) =>
      dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['debug', 'tracking'],
          data: {
            [key]: value,
          },
        },
      }),
    handleRefreshToken: ({ refreshToken }) =>
      dispatch(handleRefreshToken({ refreshToken })),
    getFpIdPro: () => dispatch(getFpIdPro({ via: 'debug-panel' })),
    postMessageToApp: payload => dispatch(postMessageToApp(payload)),
    enableEngagementDebugger: () =>
      dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['debug'],
          data: {
            engagement: true,
          },
        },
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DebugPanel);
